define('common/messages',[], function() {
    'use strict';
    var messages = {};
    messages.errorPage = {
        preCheck: 'Operations Insights could not load successfully.',
        failed: 'Operations Insights is having trouble loading. Please contact support: <a href=\'mailto:{BRAND_EMAIL}\' target=\'_top\'>{BRAND_EMAIL}</a>.'
    };

    messages.loginPage = {
        copyrightString: '\u00A9 {0} {BRAND_FULL_NAME} All Rights Reserved.',
        brandPatentInfo: '{BRAND_PATENT_INFO}',
        patentHeader :'Patent and Trademark Information'
    };

    messages.logoutPage = {
        logout: 'You have successfully signed out of Operations Insights.'
    };

    messages.failurePage = {
        reportError: [
            'The report could not be downloaded.',
            '',
            'Please contact support: <a href=\'mailto:{BRAND_EMAIL}\' target=\'_top\'>{BRAND_EMAIL}</a>.'
        ],
        serverUnreachable: 'Operations Insights is not reachable. Please try again.',
        ticketInvalid: 'Your session is not valid. Please login again from Launchpad.',
        unknownError: 'Some error has occured. Please try again.',
        dataFetch: [
                'Failed to fetch data for the dashboard.',
                '',
                'Please contact support: <a href=\'mailto:{BRAND_EMAIL}\' target=\'_top\'>{BRAND_EMAIL}</a>.'],
        casSessionCreateFailed: [
        'Failed to create session for Operations Insights.',
        '',
        'Please contact support: <a href=\'mailto:{BRAND_EMAIL}\' target=\'_top\'>{BRAND_EMAIL}</a>.'
        ]
    };

    messages.brandingInfo = {
        fullName:'{BRAND_FULL_NAME}',
        shortName: '{BRAND_SHORT_NAME}',
        supportEmail: '{BRAND_EMAIL}'
    };

    messages.general = {
        capsProductName: 'OPERATIONS INSIGHTS'
    };

    return messages;
});
